import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW6700Component } from './kymw6700.component';
import { GetProofListService } from './api-services/get-proof-list.service';


/**
 * 校正紙画面 モジュール設定クラス
 *
 * @export KYMW6700Module
 * @class KYMW6700Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6700Component,
  ],
  providers: [
    GetProofListService,
  ],
})
export class KYMW6700Module {

}
